export const DETECT_INTENT_REQUEST = 'DETECT_INTENT_REQUEST';
export const DETECT_INTENT_SUCCESS = 'DETECT_INTENT_SUCCESS';
export const DETECT_INTENT_FAILURE = 'DETECT_INTENT_FAILURE';